import { createSlice } from '@reduxjs/toolkit'

import AsyncState from '../utils/AsyncState'

const sendMilesSlice = createSlice({
  name: 'sendMiles',
  initialState: {
    sendMiles: AsyncState.create(),
  },
  reducers: {
    reset: (state) => {
      state.sendMiles = AsyncState.reset()
    },
    sendMilesStart: (state) => {
      state.sendMiles = AsyncState.start()
    },
    sendMilesSuccess: (state, action) => {
      state.sendMiles = AsyncState.success(action.payload)
    },
    sendMilesFailed: (state, action) => {
      state.sendMiles = AsyncState.failed(action.payload)
    },
  },
})

export const { actions } = sendMilesSlice

export default sendMilesSlice.reducer
